import { render, staticRenderFns } from "./DlgRemoveTrainingGuest.vue?vue&type=template&id=75b48475&scoped=true"
import script from "./DlgRemoveTrainingGuest.vue?vue&type=script&lang=ts"
export * from "./DlgRemoveTrainingGuest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b48475",
  null
  
)

export default component.exports